module.exports = __webpack_public_path__ + "static/media/IMG-20190217-WA0031.310a20de.jpg";